import { GridRowModel } from '@mui/x-data-grid-pro';
import { InventoryItem, isSingleItem } from 'common/modules/inventory';
import { Location } from 'common/types/common';
import { ColumnFieldsWithTypes } from './columns';
import { pick } from 'lodash';
import { InventoryRowItemParams } from '../../utils';
import { convertSeconds } from 'common/utils/dateUtils';

export const NO_SKU_CODE = 'No SKU';

export const getInventoryRowItems = (params: InventoryRowItemParams) => {
	const { inventoryItems, skuIds, storeLocations, statuses, selectedLocationIds } = params;

	const validIndividualItems = inventoryItems.filter((item) => {
		if (
			!!selectedLocationIds?.length &&
			!selectedLocationIds.some((locationId) => item.locationId === locationId)
		)
			return false;
		if (!!statuses?.length) {
			if (isSingleItem(item) && !statuses.includes(item.status)) return false;
			if (!isSingleItem(item) && !statuses.some((status) => !!item.statuses?.[status]))
				return false;
		}
		if (!!skuIds?.length && item.skuId && !skuIds.includes(item.skuId)) return false;
		return true;
	});

	const rows: GridRowModel<
		{ id: string } & ColumnFieldsWithTypes
	>[] = validIndividualItems.map((item) => stockItemToRow(item, storeLocations));
	return rows;
};

export const stockItemToRow = (
	stockItem: InventoryItem,
	storeLocations: Location[],
): { id: string } & ColumnFieldsWithTypes => {
	const storeName =
		storeLocations.find((l) => l.id === stockItem.locationId)?.name ?? stockItem.locationId;
	const baseObject: Omit<
		{ id: string } & ColumnFieldsWithTypes,
		'quantity' | 'status' | 'type' | 'allocations'
	> = {
		id: stockItem.id,
		article_code: !!stockItem?.identifiers?.length ? stockItem.identifiers : [],
		sku_code: stockItem.skuCode,
		sku_name: stockItem.skuName ?? '',
		usageCount: stockItem.usageCount,
		usageHours: convertSeconds(stockItem.usageSeconds, 'hours'),
		store: storeName,
		din_variation: stockItem.fixedFieldValues?.dinVariation,
		sole_length: stockItem.fixedFieldValues?.soleLength,
		state: !!stockItem.activeOrderIds?.length ? 'OUT' : 'IN',
		...stockItem.fieldValues,
	};
	if (isSingleItem(stockItem)) {
		return {
			...baseObject,
			quantity: 1,
			status: stockItem.status,
			type: 'single',
			allocations: stockItem.allocation,
		};
	}
	return {
		...baseObject,
		quantity: stockItem.quantity,
		status: stockItem.statuses,
		type: 'bulk',
		allocations: stockItem.allocations,
	};
};

export const rowToStockItem = (props: ColumnFieldsWithTypes, inventoryFieldIds: string[]) => {
	const { sku_code, sku_name, ...rest } = props;

	const fieldValues = pick(rest, inventoryFieldIds);

	return {
		sku: sku_code,
		name: sku_name,
		fieldValues,
	};
};
